<template>
  <div>
    <slot name="filter" />
    <div class="__table-top">
      <template v-if="$scopedSlots.customPlaceholderSelected && multiple && totalSelected">
        <slot name="customPlaceholderSelected" :totalSelected="totalSelected" />
      </template>
      <h6
        v-else-if="!$scopedSlots.customPlaceholderSelected && multiple && totalSelected"
        class="mc-row-check mt-0"
      >
        <span class="badge btn-success">{{ totalSelected }}</span>
        {{ $t('global.object.selectedRow') }}
        <a class="color-primary" @click="$emit('unselectAll')">{{
          $t('global.action.deselect')
        }}</a>
      </h6>
      <b-input-group size="sm" class="mc-has-search mc-input" @click="focusSearch">
        <template #prepend>
          <i class="mc-icon icon-fill_search"></i>
        </template>

        <b-form-input
          ref="searchInput"
          :value="search"
          :placeholder="$t('global.search') + '...'"
          @input="handleSearchChange"
        />
        <template v-if="search" #append>
          <button
            class="clear-search-btn"
            :disabled="isBusy || isEditing"
            @click="handleClearSearch"
          >
            <i class="pe-2 mc-icon icon-outline_close"></i>
          </button>
        </template>
      </b-input-group>

      <McButton
        v-if="attrs.hasStoreAction"
        class="mx-2"
        icon="icon-fill_plus"
        :disabled="isEditing"
        :text="$t('global.addField')"
        @click="$emit('addNewData')"
      />
    </div>
  </div>
</template>

<script>
import { debounce } from '@/helpers/debounce'

import McButton from '@/components/McButton'

export default {
  name: 'TableHeader',
  components: {
    McButton,
  },
  props: {
    attrs: {
      type: Object,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
    },
    totalSelected: {
      type: Number,
    },
  },
  emits: ['update:search', 'unselectAll', 'addNewData'],
  methods: {
    handleSearchChange: debounce(async function (_search) {
      this.$emit('update:search', _search)
      // TODO: handle focus after search change
      this.$refs['searchInput'].$el.focus()
    }, 500),
    handleClearSearch() {
      this.handleSearchChange('')
    },

    focusSearch() {
      this.$refs['searchInput'].focus()
    },
  },
}
</script>

<style lang="scss" scoped>
// TODO: Refactor this selector
.mc-input {
  background: $white;
  border: 1px solid $teal-200;
  border-radius: 4px;
  line-height: 16px;
  font-family: $font-family-sans-serif;
  color: #344264;
  font-size: 12px;
  width: 100%;
  justify-content: space-between;

  &.input-md {
    height: 37px;
    padding: 10.5px 10px;
  }

  &.input-sm {
    height: 27px;
    padding: 5.5px 10px;
  }

  & > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    cursor: pointer;
  }

  input {
    padding: 0px;
  }

  input::placeholder {
    color: $teal-200;
    font-size: 12px;
  }

  i {
    margin: -11px;
    margin-left: 0px;
    padding: 8.5px;
    &::before {
      display: block;
      color: #67718b;
      font-size: 20px;
      line-height: none;
    }
  }

  &.__disabled {
    background-color: $gray;
    color: $teal-200;
    cursor: default;

    i::before {
      color: $teal-200;
    }

    input {
      background-color: $gray;
    }
  }
}

.__table-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.mc-has-search {
  padding: 10.5px;
  padding-left: 10px;
  max-width: 30%;
  margin-left: auto;

  // if search is disabled
  &:has(input:disabled) {
    background: $input-disabled-bg;
  }

  .clear-search-btn {
    border: none;
    background-color: transparent;
    padding: 0px;
    margin: 0px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .clear-search-btn:disabled {
    cursor: default;
  }

  input {
    border: none;
    border-radius: 4px;

    padding: 0;
    padding-left: 8px;

    font-size: 12px;
  }

  .input-group-prepend,
  .input-group-append {
    border: none;
    display: flex;
    align-items: center;

    .mc-icon {
      padding-left: 0;
      &:before {
        font-size: 16px;
        color: $input-placeholder-color;
      }
    }
  }
}
</style>
